import { AppConfig } from "./app.config";

export const appConfigProd: AppConfig = {
  DEFAULT_TITLE: 'Blueticks',
  asset_key: 'blueticks',
  pricingOptions: 'extension',
  google_client_id: '143723739146-oa75527ckplc3kb9nk8q41redtoq6t18.apps.googleusercontent.com',
  GTM_ID: 'GTM-NGKDFBM',
  GA_ID: 'G-RCEGPEQEZ5',
  CLARITY_ID:'',
  TIKTOK_ID:'',
  CRISP_ID: 'f317863d-feb0-4f63-9ae2-fb8280d54a53',
  FB_PIXEL_ID: '967346226362151',
  AW_ID: '',
  WS_ID: 'G-8YP76PWS2J',
  HJ_ID: 2742843,
  HJ_SV: 6,
  ENV: "production",
  isProd: true,
  EXTENTION_ID: "adgnjhngogijkkppficiiepmjebijinl",
  GATEWAY_ENDPOINT: "https://gateway.blueticks.co",
  NOTIFIER_ENDPOINT: "https://notify.blueticks.co",
  DOCS_ENDPOINT: "https://dev.blueticks.co",
  VZNLYTICS_ENDPOINT: "https://analytics.blueticks.co",
  API_ENDPOINT: "https://api.blueticks.co",
  PRICING_PAGE: "https://app.blueticks.co",
  APP_ENDPOINT: "https://app.blueticks.co",
  HOMEPAGE: "https://blueticks.co",
  LOGO:"/img/tudu-logo.svg",
  LOGO2:"/img/tudo-logo-icon.svg",
  PAYPAL_CLIENT_ID:
    "AafpAM2aA4Lqus7h_iAa2szoitZM7-hkyZaU5jjYOtv-KqcuZCpFFlpbluVp4_F-6fQhcIui7AWZs9Ah",
  BLUESNAP_ENDPOINT: "https://bluesnap.com",
  BLUESNAP_STORE_ID: "648495",
  BLUESNAP_REDIRECT_ENC:
    "y3BO7mSu04vXEh55QSFI51vnnO%2FrL2uZ10%2FPUF2Fh8urn%2BFdpIn4tyxpPqhcCnm%2BVOdueGkdnZpbpSjw%2Fj215nog250lMwUyqKry1OkfDap8daL1Nxv4dJeDeSXd9Ai6vUKYhCKeZaQ%2ByyfLkDPwJwlx1BGnPQYlRYkYiZBknRcVCl6kAgHv5ZTKEc3YMGPO4kc9iJJQnqXsotsbI3Z5jgJ5rXvslcQJXPihvCycO2%2FJfYH%2F2cr5s6ZLhSZZZaZY",
  
  extensionStoreLink: "https://chrome.google.com/webstore/detail/blueticks/adgnjhngogijkkppficiiepmjebijinl",
  MQTT_BROKER_URL: "wss://mqtt.blueticks.co:443/mqtt",
};
export default appConfigProd;
